import React, { useContext } from 'react';

import { InputLabel } from 'components/form/prototypes';
import { NCRContext } from 'views';
import { UserContext } from 'components/routing';
import { currencySymbol } from 'utils/helpers';
import { defaultRestockPercent } from 'utils/constants';

const ReturnTotalCosts = () => {
  const { state } = useContext(NCRContext);
  const { user } = useContext(UserContext);

  const isDisabled = ['QA', 'GM'].includes(user.role)
    ? state.ncr.status.id > 8
    : state.ncr.status.id > 1;

  return (
    <>
      <InputLabel
        name="ncr.return.discount"
        label="Average Discount %"
        number
        min={0}
        max={100}
        step={1}
        placeholder={0}
        disabled={isDisabled}
      />
      <InputLabel
        name="ncr.return.restock_percent"
        label="Restock Charge %"
        value={state.ncr.return.restock_percent || defaultRestockPercent}
        disabled
      />
      <InputLabel
        name="ncr.return.total_cost"
        label="Total Cost"
        value={currencySymbol(
          state.currencies[state.ncr.subsidiary?.currency],
          state.ncr.return.total_cost
        )}
        disabled
      />
      <InputLabel
        name="ncr.return.restock_cost"
        label={`Restock cost to ${state.ncr.return.restock_charge?.name}`}
        value={currencySymbol(
          state.currencies[state.ncr.subsidiary?.currency],
          state.ncr.return.restock_cost
        )}
        disabled
      />
    </>
  );
};
export { ReturnTotalCosts };
